import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-display font-black text-2xl tracking-tighter flex items-center gap-2">
              <span className="inline-block w-2 h-2 bg-[#D30000]" />
              MHorgas<span className="text-[#D30000]">Consult</span>
            </div>
            <p className="mt-6 text-white/60 max-w-md leading-relaxed">
              Spezialist für Ausrüstungs­investitionen — Begleitung von
              Vertrieb und Führung, Pay-per-Use-Spezial­finanzierung in
              Kooperation mit Linxfour und Förder­mittel auf Erfolgs­basis als
              Repräsentant der REM Capital AG.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-4">
              Bereiche
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="#saeulen" className="hover:text-[#FF4747] transition-colors">Säulen</a></li>
              <li><a href="#ueber-mich" className="hover:text-[#FF4747] transition-colors">Über mich</a></li>
              <li><a href="#begleitung" className="hover:text-[#FF4747] transition-colors">Begleitung</a></li>
              <li><a href="#pay-per-use" className="hover:text-[#FF4747] transition-colors">Pay-per-Use</a></li>
              <li><a href="#foerdermittel" className="hover:text-[#FF4747] transition-colors">Fördermittel</a></li>
              <li><a href="#kontakt" className="hover:text-[#FF4747] transition-colors">Kontakt</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-4">
              Kontakt
            </div>
            <ul className="space-y-2 text-sm text-white/80">
              <li>michaelhorgas@mhorgasconsult.com</li>
              <li>+49 1525 1678724</li>
              <li>Hamburg</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <div>© {year} Michael Horgas Consult. Alle Rechte vorbehalten.</div>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-datenschutz">Datenschutz</Link>
            <a href="#kontakt" className="hover:text-white transition-colors" data-testid="footer-kontakt">Kontakt</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
